export const GET_USER_WORKSHOP =
  'global/hooks/useUserWorkshop/getUserWorkshop'
